// Inventory photos/videos, the estimate and the job card attached while booking
// a service. They are uploaded before the group exists (so there is no row to
// hang them on) and travel with the booking as ro_media_urls / ro_estimate_url /
// ro_card_url; the backend sends them later — see
// apps/api/wa_worker.BOOKING_DOCUMENTS.

import { authBackend } from "./authBackend";

// Upload through the backend so the privileged storage credentials never reach
// the client. `stage` and the names only decide what the file is called
// (Customer_Vehicle_Estimate.pdf) — the backend builds it, so the booking forms
// and the Service Journey name files the same way.
export async function uploadBookingDoc(file, { stage, customerName, vehicle, index = 0, total = 1 }) {
  const {
    data: { session },
  } = await authBackend.getSession();
  const token = session?.access_token;
  const form = new FormData();
  form.append("file", file);
  form.append("stage", stage);
  form.append("index", String(index));
  form.append("total", String(total));
  form.append("customer_name", customerName || "");
  form.append("group_name", vehicle || "");
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/upload-doc`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Upload failed");
  }
  const { url } = await res.json();
  return url;
}

// The optional attachments of a booking form -> the booking payload fields.
// Any may be missing; only what was chosen is uploaded and returned.
export async function uploadBookingDocs({ estimate, jobCard, media = [] }, names) {
  const [roEstimateUrl, roCardUrl, mediaUrls] = await Promise.all([
    estimate ? uploadBookingDoc(estimate, { stage: "estimate", ...names }) : null,
    jobCard ? uploadBookingDoc(jobCard, { stage: "job_card", ...names }) : null,
    Promise.all(media.map((file, index) => uploadBookingDoc(file, { stage: "media", ...names, index, total: media.length }))),
  ]);
  return {
    ...(roEstimateUrl ? { ro_estimate_url: roEstimateUrl } : {}),
    ...(roCardUrl ? { ro_card_url: roCardUrl } : {}),
    // Newline-separated, the same shape as Media Link.
    ...(mediaUrls.length ? { ro_media_urls: mediaUrls.join("\n") } : {}),
  };
}
